import { Component, Inject, OnInit, Output, EventEmitter } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogContent, MatDialogClose } from '@angular/material/dialog';
import { IMultiStoreSelect } from 'src/app/common/models/multiStoreSelect';
import { MultiPrepSelect } from 'src/app/common/models/multiPrepSelect';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { MultiPrepChecklist } from '../../multi-prep-checklist/multi-prep-checklist.component';
import { MatButton } from '@angular/material/button';

export interface IMultiPrepLocationDialogData {
  multiPrepLocationData: MultiPrepSelect[];
  prepLocationName: string;
  edits?: string[];
}

@Component({
  selector: 'multi-prep-location-select',
  templateUrl: './multi-prep-location.component.html',
  styleUrls: ['./multi-prep-location.component.scss'],
  standalone: true,
  imports: [CdkScrollable, MatDialogContent, MultiPrepChecklist, MatButton, MatDialogClose],
})
export class MultiPrepLocationComponent implements OnInit {
  @Output() public outputFacilitiesEvent? = new EventEmitter<IMultiStoreSelect[]>();
  public prepLocations: MultiPrepSelect[] = [];
  public edits: string[] = [];

  constructor(
    public dialogRef: MatDialogRef<MultiPrepLocationComponent>,
    @Inject(MAT_DIALOG_DATA) public dialogInput: IMultiPrepLocationDialogData,
  ) {}

  public ngOnInit(): void {
    this.edits = this.dialogInput.edits || [];

    if (this.dialogInput.multiPrepLocationData.length === 0) {
      return;
    }

    this.prepLocations = structuredClone(this.dialogInput.multiPrepLocationData);
  }

  public onNoClick(): void {
    this.dialogRef.close();
  }
}
